import { DEFAULT_LANGUAGE } from "../../../../../company/settings/translations";
import { Maybe } from "../../../types/thecookies";

export function getCodeLang(language: Maybe<string>): string {
  const code = language || DEFAULT_LANGUAGE;

  return code.replace("_", "-");
}

export function getLangNormalize(language: Maybe<string>): string {
  const code = language || DEFAULT_LANGUAGE;
  return code.replace("-", "_");
}
